import {Component, Inject, OnInit} from '@angular/core';
import {StatePersistenceService} from '../service/state.persistence.service';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {SeoService} from '../service/seo.service';
import {InventoryControllerService} from '../@api';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document,
                private router: Router,
                public state: StatePersistenceService,
                private inventoryControllerService: InventoryControllerService,
                private seoService: SeoService) {
    }

    ngOnInit(): void {
        let title: string = 'Solar Central | Solar Quotes | Search, Compare & Save!';
        let keywords: string = 'solar, accredited installers, south africa, solar quotes, residential solar, solar panels, inverter, competitive prices, local solar installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, solar installers gauteng, solar installers, quotes from local professionals, free estimates from local pros, try solar central to find a solar panel installer now, south africa';
        let description: string = 'Try Solar Central to Find a Solar Installer Now. Submit your energy usage by using our interactive wizard. Get multiple quotes from accredited installers in your local area. Solar Central - Fast, Free & Simple';

        this.seoService.updateMetaTags({
            title: title,
            description: description,
            keywords: keywords
        });

        this.setCanonicalURL();
    }

    setCanonicalURL(url: string = 'https://www.solarcentral.co.za/'): void {
        let link: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');

        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }

        link.setAttribute('href', url);
    }

    continue(): void {
        this.router.navigate(['/rfq']);
    }
}
